import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface SponsorsDialogData {
  title: string;
  sponsors: { logoUrl: string; name: string }[];
}

@Component({
  selector: 'app-sponsors-content',
  imports: [CommonModule],
  templateUrl: './sponsors-content.component.html',
  styleUrls: ['./sponsors-content.component.scss']
})
export class SponsorsContentComponent {
  readonly data = inject<SponsorsDialogData>(MAT_DIALOG_DATA);
}
